export default {
	er_cover_default_title: 'Prehľad výkonu',
	er_page_success_metrics: 'Čo sa tento mesiac zmenilo',
	er_page_success_metrics_range: 'Čo sa v tomto období zmenilo',
	er_page_success_metrics_week: 'Čo sa tento týždeň zmenilo',
	er_page_comparison: 'Porovnávací súhrn',
	er_page_period_summary: 'Súhrn mesiaca',
	er_page_period_summary_range: 'Súhrn obdobia',
	er_page_period_summary_week: 'Súhrn týždňa',
	er_page_each_month: 'Každý mesiac',
	er_page_rooms: 'Miestnosti',
	er_rooms_note: 'Každá miestnosť v {month}, najlepšie skóre prvé.',
	er_page_shift_comparison: 'Porovnanie podľa zmeny',
	er_page_shift_summary: 'Podľa zmeny',
	er_page_response_time: 'Priemerný čas odozvy (min)',
	er_page_avg_score: 'Skóre zážitku',
	er_page_complaints_vs_visits: 'Sťažnosti vs návštevy',
	er_page_performance_trends: 'Trendy výkonu',
	er_page_complaint_drivers: 'Príčiny sťažností',

	er_board_working: 'Lepšie ako {month}',
	er_board_attention: 'Vyžaduje pozornosť oproti {month}',
	er_board_empty: 'Tento mesiac nie sú žiadne podstatné zmeny.',
	er_board_empty_range: 'V tomto období nie sú žiadne podstatné zmeny.',
	er_board_empty_week: 'Tento týždeň nie sú žiadne podstatné zmeny.',
	er_findings_intro: 'Porovnanie s {month}. Zobrazujú sa len podstatné zmeny.',
	er_verdict_improved: 'Zlepšenie',
	er_verdict_watch: 'Vyžaduje pozornosť',

	er_col_metric: 'Ukazovateľ',
	er_col_avg: 'Priem. YTD',
	er_col_lifetime_avg: 'Priem. od začiatku',
	er_comparison_note: 'Priem. YTD je údaj od januára do {month}.',
	er_lifetime_note: 'Od začiatku je mesačný priemer od prvého dňa s údajmi do {month}.',
	er_comparison_note_week: 'Týždeň reportu sa porovnáva s vybraným predchádzajúcim týždňom.',
	er_period_only_note: 'Údaje platia len pre {month}.',
	er_each_month_note: 'Každý mesiac vo zvolenom období. Mesiac bez údajov ostane prázdny.',
	er_col_inc_dec: 'Zmena',
	er_col_complaint: 'Sťažnosť',
	er_col_qty: 'Počet',
	er_total: 'Spolu',

	er_metric_avg_score: 'Skóre zážitku',
	er_metric_avg_response_time: 'Priemerný čas odozvy',
	er_metric_cleaner_arrivals: 'Príchody upratovania',
	er_metric_supervisor_inspections: 'Kontroly supervízorov',
	er_metric_complaints_vs_visits_pct: 'Sťažnosti vs. návštevy (%)',
	er_metric_complaints: 'Sťažnosti',
	er_metric_customer_visits: 'Návštevy',
	er_metric_expired_slas: 'Exspirované SLA',
	er_unit_min: 'min',
	er_stat_expected_sla: 'Očakávané SLA',
	er_stat_vs_minutes: 'oproti {value} v {month}',
	er_stat_vs_count: 'oproti {value} v {month}',
	er_label_complaints: 'Sťažnosti',
	er_label_visits: 'Návštevy',
	er_label_complaints_per_visits: 'Sťažnosti / návštevy',
	er_chart_ratio: 'Pomer sťažností k návštevám',
	er_chart_ytd_window: 'Od januára do {month}.',
	er_cv_formula: 'Sťažnosti delené návštevami toaliet, v percentách: ({complaints} ÷ {visits}) × 100 = {ratio} % v {month}.',
	er_export_kpis_title: 'Čo report obsahuje',
	er_export_kpis_desc: 'Všetko toto je v reporte. Vypnite položku, ktorú nechcete.',
	er_export_select_all: 'Vybrať všetko',
	er_export_clear_all: 'Zrušiť výber',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Obdobie reportu',
	er_export_grain: 'Zostaviť podľa',
	er_export_grain_month: 'Mesiac',
	er_export_grain_week: 'Týždeň',
	er_export_week_starts: 'Týždeň začína',
	er_export_week_starts_sunday: 'nedeľou',
	er_export_week_starts_monday: 'pondelkom',
	er_export_report_month: 'Mesiac reportu',
	er_export_from_month: 'Od',
	er_export_to_month: 'Do',
	er_export_period_note_range: 'Report sčíta každý mesiac od začiatku do konca. Pri zapnutom porovnaní sa použije predchádzajúce obdobie rovnakej dĺžky. Údaje od začiatku roka stále idú od januára do koncového mesiaca.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'Predchádzajúce obdobie rovnakej dĺžky.',
	er_export_report_week: 'Týždeň reportu',
	er_export_compare_month: 'Porovnať s',
	er_export_shift: 'Zmena',
	er_export_shift_all: 'Všetky zmeny',
	er_export_no_shifts: 'Toto miesto nemá žiadne aktívne zmeny.',
	er_export_render_failed: 'Prehľad sa nepodarilo správne vykresliť, preto sa nestiahol. Obnovte stránku a skúste to znova.',
	er_export_comparison: 'Porovnanie',
	er_export_include_previous: 'Zahrnúť predchádzajúce obdobie',
	er_export_comparison_on: 'Zapnuté',
	er_export_comparison_off: 'Vypnuté',
	er_export_no_previous_data: 'Pred týmto obdobím nie sú žiadne údaje, takže nie je s čím porovnávať.',
	er_export_compare_previous: 'Predchádzajúci mesiac',
	er_export_compare_previous_week: 'Predchádzajúci týždeň',
	er_export_compare_last_year: 'Rovnaký mesiac vlani',
	er_export_no_periods: 'Tento objekt potrebuje aspoň jeden mesiac údajov, aby sa dal report exportovať.',
	er_export_no_periods_week: 'Tento objekt potrebuje aspoň jeden týždeň údajov, aby sa dal report exportovať.',
	er_export_period_note: 'Zobrazujú sa len mesiace s údajmi. Údaje od začiatku roka vždy zahŕňajú január až mesiac reportu.',
	er_export_period_note_week: 'Zobrazujú sa len týždne s údajmi. Porovnanie je vždy s predchádzajúcim týždňom.',
	er_export_period_note_single_week: 'Zobrazujú sa len týždne s údajmi.',

	er_find_response_time_title: 'Priemerný čas odozvy',
	er_find_response_time_change:
		'Zmenilo sa z {previous} na {current} minút ({change}).',
	er_find_avg_score_title: 'Skóre zážitku',
	er_find_score_eased: 'Kleslo z {previous} na {current}.',
	er_find_score_improved: 'Stúplo z {previous} na {current}.',
	er_find_score_ytd_inline: 'Zodpovedá priemeru od začiatku roka {ytd}.',
	er_find_score_ytd_inline_range: 'Zhoduje sa s priemerom od januára do {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Priemer od začiatku roka: {ytd}.',
	er_find_score_ytd_against_range: 'Priemer od januára do {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Pomer sťažností k návštevám',
	er_find_complaints_ratio_improved: 'Zlepšilo sa z {previous} na {current}.',
	er_find_complaints_ratio_rose: 'Zmenilo sa z {previous} na {current}.',

	er_nar_cv_year_improved: 'Sťažnosti voči návštevám toaliet sa počas roka zlepšili z {from} na {to}.',
	er_nar_cv_year_rose: 'Sťažnosti voči návštevám toaliet počas roka vzrástli z {from} na {to}.',
	er_nar_cv_moved: 'Sťažnosti voči návštevám toaliet sa zmenili z {previous} na {current}.',
	er_nar_cv_current: 'Sťažnosti voči návštevám toaliet sú na úrovni {current}.',
	er_nar_types_total: 'Spolu sťažností {total}.',
	er_nar_types_1: 'Najčastejšia sťažnosť: {a} ({ap} %).',
	er_nar_types_2: 'Najčastejšia sťažnosť: {a} ({ap} %), nasleduje {b} ({bp} %).',
	er_nar_types_3: 'Najčastejšia sťažnosť: {a} ({ap} %), nasleduje {b} ({bp} %) a {c} ({cp} %).',
	er_find_rooms_slowest: 'Miestnosti s najdlhším časom odozvy tento mesiac: {rooms}.',
	er_find_rooms_slowest_range: 'Miestnosti s najdlhším časom odozvy v tomto období: {rooms}.',
	er_find_rooms_slowest_week: 'Miestnosti s najdlhším časom odozvy tento týždeň: {rooms}.',
	er_find_rooms_lowest_score: 'Miestnosti s najnižším skóre tento mesiac: {rooms}.',
	er_find_rooms_lowest_score_range: 'Miestnosti s najnižším skóre v tomto období: {rooms}.',
	er_find_rooms_lowest_score_week: 'Miestnosti s najnižším skóre tento týždeň: {rooms}.',

	er_find_so_what_ratio: 'Väčšina zmeny pochádzala z {rooms}.',
	er_find_so_what_type: 'Hlavná sťažnosť: {name} ({percent}%).',
	er_hot_slowest: 'Miestnosti s najdlhším časom odozvy',
	er_hot_expired_slas: 'Miestnosti, ktoré prekročili SLA',
	er_hot_ratio: 'Miestnosti s najväčšou zmenou miery sťažností',
	er_hot_top_type: 'Miestnosti s najväčším počtom sťažností „{name}“',
	er_hot_col_room: 'Miestnosť',
	er_col_response: 'Odozva',
	er_col_cleaners: 'Upratovanie',
	er_col_score: 'Skóre',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Pomer',
	er_hot_col_change: 'Zmena',
	er_hot_col_count: 'Počet',
	er_hot_empty: 'Tento mesiac nie sú žiadne miestnosti na zvýraznenie.',
	er_hot_empty_range: 'V tomto období nie sú žiadne miestnosti na zvýraznenie.',
	er_hot_empty_week: 'Tento týždeň nie sú žiadne miestnosti na zvýraznenie.',
	er_cover_highlights: 'Tento mesiac',
	er_cover_highlights_range: 'Toto obdobie',
	er_cover_highlights_week: 'Tento týždeň',
	er_cover_score_rose: 'Skóre zážitku stúplo.',
	er_cover_score_eased: 'Skóre zážitku kleslo.',
	er_cover_response_improved: 'Čas odozvy sa zlepšil.',
	er_cover_response_slowed: 'Čas odozvy sa predĺžil.',
	er_cover_ratio_fell: 'Pomer sťažností k návštevám klesol.',
	er_cover_ratio_rose: 'Pomer sťažností k návštevám stúpol.',
	er_export_pdf: 'PDF prehľadu',
	er_export_executive: 'Manažérska správa',
	'executive-report': 'Manažérska správa',
	er_export_csv: 'CSV',
	er_export_status_title: 'Vytvárame report',
	er_export_status_fetch: 'Načítavame čísla',
	er_export_status_layout: 'Pripravujeme strany',
	er_export_status_page: 'Strana {page} z {total}',
	er_footer_copyright: 'Tento report bol vygenerovaný prostredníctvom systému BuzzzTech.',
	er_contact_line: 'Máte otázky alebo chcete údaje preskúmať podrobnejšie? Kontaktujte tím Customer Success BuzzzTech: {email} alebo {phone}.',
};
